import React from "react";

import { Icon, Text } from "@soluto-design/react";
import Link, { LinkProps } from "@soluto-design/link";
import cls from "@soluto-design/styles/cls";

export interface BlogShareProps {
  title?: string;
  links: LinkProps[];
}

const BlogShare: React.FC<BlogShareProps> = ({ links, title }) => {
  return (
    <>
      {title && (
        <Text component="p" className="text-h400 text-text-primary pb-8">
          {title}
        </Text>
      )}
      {links && links.length > 0 && (
        <ul className={cls("flex gap-x-12 items-center")}>
          {links?.map((link, i) => (
            <li
              key={`social-${i}`}
              className="inline-flex items-center justify-center rounded-round bg-background-tertiary h-32 w-32"
            >
              <Link href={link?.url} target="_blank">
                <Icon icon={link?.icon} className="text-[20px]" />
              </Link>
            </li>
          ))}
        </ul>
      )}
    </>
  );
};

export default BlogShare;
